
export enum ClientState {
    NotLoaded,
    NotLoggedIn,
    Ready,
    
    ReportView,
}
